<template>
  <v-app id="app" class="main-container">
      <main-form></main-form>
  </v-app>
</template>

<script>
  import MainForm from "@/components/MainForm";
  import * as axe from "axe-core";

  export default {
    name: 'App',
    components: {MainForm},
    mounted() {

    },
  }
</script>
